module.exports = __webpack_public_path__ + "img/11.95a87d21.jpg";